import {
  BreadcrumbLevel,
  Breadcrumbs,
} from '@app/components/core/breadcrumbs/Breadcrumbs'
import { pages } from '@app/util/links'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { useLocation } from 'wouter'

export type PageBreadcrumbsProps = {
  level2: string
  level3?: string
}

export const PageBreadcrumbs = ({ level2, level3 }: PageBreadcrumbsProps) => {
  const [location] = useLocation()
  const [language, _] = useLanguage()
  const pageNames = i18n.languages[language].app.pageNames
  const locationParts = location.split('/')
  locationParts.pop()
  const level2Page = [...locationParts].join('/')
  const levels: BreadcrumbLevel[] = [
    {
      label: pageNames.home,
      to: pages.home,
    },
    {
      label: level2,
      to: level3 ? level2Page : undefined,
    },
  ]

  if (level3) {
    levels.push({ label: level3 })
  }

  return <Breadcrumbs levels={levels} />
}
